import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AssetsGenerateUrlService, AssetUIModel, ClientCoreModule } from '@thehubz/client/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'thehubz-asset-video',
  templateUrl: './asset-video.component.html',
  styleUrls: ['./asset-video.component.scss'],
  standalone: true,
  imports: [CommonModule, ClientCoreModule],
})
export class AssetVideoComponent implements OnInit {
  @Input() asset!: AssetUIModel;
  @Input() toolbar = false;

  videoURL$!: Observable<string>;

  constructor(private assetsUrlService: AssetsGenerateUrlService) {}

  ngOnInit(): void {
    this.videoURL$ = this.assetsUrlService.getResizedPresignedUrl$(this.asset);
  }

  onError() {
    // could happen that the url expired, so we get a new one
    this.videoURL$ = this.assetsUrlService.getResizedPresignedUrl$(this.asset);
  }
}
